import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { haritaUrl, yolTarifiUrl, tarihOku, saatStr, tarihStr, gunEkle, GUN_KISA } from '../components/randevu/randevuOrtak';
import '../components/takip/takip.css';
import '../components/randevu/randevu.css';

// Müşterinin SMS / e-postadaki bağlantıyla randevusunu görüntüleyip onayladığı ya da iptal ettiği sayfa (oturum gerekmez)
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5159';

interface Veri {
    baslik: string; turAdi?: string | null; baslangic: string; bitis: string; konum?: string | null;
    personelAdi?: string | null; personelTelefon?: string | null; firmaAdi: string; durum: string; musteriOnay?: string | null; islemYapilabilir: boolean;
    degistirilebilir?: boolean; sureDk?: number; ilkGun?: string; sonGun?: string;
}

const RandevuOnay: React.FC = () => {
    const { token } = useParams<{ token: string }>();
    const [veri, setVeri] = useState<Veri | null>(null);
    const [hata, setHata] = useState('');
    const [mesaj, setMesaj] = useState('');
    const [iptalAcik, setIptalAcik] = useState(false);
    const [neden, setNeden] = useState('');
    const [isleniyor, setIsleniyor] = useState(false);
    // Randevuyu değiştirme (v1.24.0): personelin müsait saatlerinden yeni saat
    const [degistirAcik, setDegistirAcik] = useState(false);
    const [yeniGun, setYeniGun] = useState('');
    const [saatler, setSaatler] = useState<string[] | null>(null);
    const [yeniSaat, setYeniSaat] = useState('');

    const yukle = useCallback(async () => {
        try {
            const r = await fetch(`${API_BASE}/api/RandevuPortal/randevu/${token}`);
            const d = await r.json();
            if (!r.ok) { setHata(d.message || 'Randevu bulunamadı.'); return; }
            setVeri(d);
        } catch { setHata('Bağlantı hatası. Lütfen daha sonra tekrar deneyin.'); }
    }, [token]);
    useEffect(() => { yukle(); }, [yukle]);

    const islem = async (tur: 'onayla' | 'iptal') => {
        setIsleniyor(true); setMesaj('');
        try {
            const r = await fetch(`${API_BASE}/api/RandevuPortal/randevu/${token}/${tur}`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(tur === 'iptal' ? { neden } : {}),
            });
            const d = await r.json();
            setMesaj(d.message || (r.ok ? 'İşlem tamamlandı.' : 'İşlem yapılamadı.'));
            setIptalAcik(false);
            yukle();
        } catch { setMesaj('Bağlantı hatası.'); }
        finally { setIsleniyor(false); }
    };

    const gunler = React.useMemo(() => {
        if (!veri?.ilkGun || !veri?.sonGun) return [] as Date[];
        const l: Date[] = [];
        for (let d = new Date(veri.ilkGun + 'T00:00:00'); tarihStr(d) <= veri.sonGun && l.length < 60; d = gunEkle(d, 1)) l.push(d);
        return l;
    }, [veri?.ilkGun, veri?.sonGun]);
    useEffect(() => {
        if (!degistirAcik || !yeniGun) return;
        setSaatler(null); setYeniSaat('');
        fetch(`${API_BASE}/api/RandevuPortal/randevu/${token}/saatler?gun=${yeniGun}`).then(r => r.json()).then(d => setSaatler(Array.isArray(d) ? d : [])).catch(() => setSaatler([]));
    }, [degistirAcik, yeniGun, token]);
    const degistir = async () => {
        if (!yeniGun || !yeniSaat) return;
        setIsleniyor(true); setMesaj('');
        try {
            const r = await fetch(`${API_BASE}/api/RandevuPortal/randevu/${token}/degistir`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ baslangic: `${yeniGun}T${yeniSaat}:00` }),
            });
            const d = await r.json();
            setMesaj(d.message || (r.ok ? 'Randevunuz güncellendi.' : 'Değiştirilemedi.'));
            if (r.ok) { setDegistirAcik(false); yukle(); }
            else if (r.status === 409) {
                setYeniSaat('');
                fetch(`${API_BASE}/api/RandevuPortal/randevu/${token}/saatler?gun=${yeniGun}`).then(x => x.json()).then(x => setSaatler(Array.isArray(x) ? x : [])).catch(() => { });
            }
        } catch { setMesaj('Bağlantı hatası.'); }
        finally { setIsleniyor(false); }
    };

    const bas = veri ? tarihOku(veri.baslangic) : null;
    const durumMetni = !veri ? '' : veri.durum === 'IPTAL' ? 'İptal edildi' : veri.durum === 'TAMAMLANDI' ? 'Tamamlandı' : veri.durum === 'ERTELENDI' ? 'Ertelendi'
        : veri.musteriOnay === 'ONAYLADI' ? 'Onayladınız' : 'Onayınız bekleniyor';

    return (
        <div className="rnd-acik">
            <div className="rnd-acik-kart">
                <div className="rnd-acik-bas">
                    <div className="firma">{veri?.firmaAdi}</div>
                    <h1>Randevunuz</h1>
                </div>
                <div className="rnd-acik-govde">
                    {hata && <div className="tkp-hata">{hata}</div>}
                    {!veri && !hata && <div style={{ textAlign: 'center', padding: 30, color: '#9ca3af' }}><i className="fas fa-spinner fa-spin" style={{ fontSize: 24 }}></i></div>}
                    {veri && bas && (
                        <>
                            <div style={{ fontSize: 20, fontWeight: 800, color: '#1a2440', textTransform: 'capitalize' }}>
                                {bas.toLocaleDateString('tr-TR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
                            </div>
                            <div style={{ fontSize: 28, fontWeight: 800, color: '#e67d21', margin: '2px 0 12px' }}>{saatStr(bas)} – {saatStr(tarihOku(veri.bitis))}</div>
                            <div className="tkp-bilgi-izgara" style={{ marginBottom: 12 }}>
                                <div className="tkp-bilgi"><div className="e">Konu</div><div className="d">{veri.turAdi ?? veri.baslik}</div></div>
                                {veri.personelAdi && <div className="tkp-bilgi"><div className="e">Görüşeceğiniz kişi</div><div className="d">{veri.personelAdi}</div>
                                    {veri.personelTelefon && <a href={`tel:${veri.personelTelefon}`} style={{ fontSize: 12 }}><i className="fas fa-phone" style={{ marginRight: 4 }}></i>{veri.personelTelefon}</a>}</div>}
                                <div className="tkp-bilgi"><div className="e">Durum</div><div className="d" style={{ color: veri.durum === 'IPTAL' ? '#dc2626' : veri.musteriOnay === 'ONAYLADI' ? '#16a34a' : '#b45309' }}>{durumMetni}</div></div>
                            </div>
                            {veri.konum && (
                                <div style={{ background: '#f8fafc', borderRadius: 10, padding: '10px 12px', marginBottom: 12 }}>
                                    <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase' }}>Konum</div>
                                    <div style={{ fontSize: 14, color: '#1a2440', margin: '2px 0 8px' }}>{/^https?:/i.test(veri.konum) ? <a href={veri.konum}>{veri.konum}</a> : veri.konum}</div>
                                    {!/^https?:/i.test(veri.konum) && (
                                        <div style={{ display: 'flex', gap: 8 }}>
                                            <a className="tkp-btn" href={haritaUrl(veri.konum)} target="_blank" rel="noreferrer"><i className="fas fa-map"></i>Haritada aç</a>
                                            <a className="tkp-btn ana" href={yolTarifiUrl(veri.konum)} target="_blank" rel="noreferrer"><i className="fas fa-route"></i>Yol tarifi</a>
                                        </div>
                                    )}
                                </div>
                            )}
                            {mesaj && <div style={{ background: '#ecfdf5', border: '1px solid #a7f3d0', color: '#047857', borderRadius: 8, padding: '10px 12px', fontSize: 14, marginBottom: 12 }}>{mesaj}</div>}
                            {degistirAcik && (
                                <div style={{ background: '#f8fafc', borderRadius: 10, padding: 12, marginBottom: 12 }}>
                                    <div className="rnd-adim" style={{ marginTop: 0 }}>Yeni gün</div>
                                    <div className="rnd-gun-serit">
                                        {gunler.map(d => (
                                            <button key={tarihStr(d)} className={yeniGun === tarihStr(d) ? 'aktif' : ''} onClick={() => setYeniGun(tarihStr(d))}>
                                                <div className="g">{GUN_KISA[d.getDay()]}</div><div className="n">{d.getDate()}</div><div className="a">{d.toLocaleDateString('tr-TR', { month: 'short' })}</div>
                                            </button>
                                        ))}
                                    </div>
                                    {yeniGun && (
                                        <>
                                            <div className="rnd-adim">Saat</div>
                                            {saatler === null && <div className="tkp-bos"><i className="fas fa-spinner fa-spin"></i></div>}
                                            {saatler && saatler.length === 0 && <div className="tkp-bos">Bu gün için boş saat yok, başka bir gün seçin.</div>}
                                            {saatler && saatler.length > 0 && (
                                                <div className="rnd-secim">{saatler.map(s => <button key={s} className={yeniSaat === s ? 'aktif' : ''} onClick={() => setYeniSaat(s)}>{s}</button>)}</div>
                                            )}
                                        </>
                                    )}
                                    <div style={{ display: 'flex', gap: 8, marginTop: 12, justifyContent: 'flex-end' }}>
                                        <button className="tkp-btn" onClick={() => setDegistirAcik(false)}>Vazgeç</button>
                                        <button className="tkp-btn turuncu" disabled={isleniyor || !yeniSaat} onClick={degistir}>
                                            <i className="fas fa-check"></i>{yeniSaat ? `${new Date(yeniGun + 'T00:00:00').toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' })} ${yeniSaat} olarak değiştir` : 'Saat seçin'}
                                        </button>
                                    </div>
                                </div>
                            )}
                            {veri.islemYapilabilir && !iptalAcik && !degistirAcik && (
                                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                                    {veri.musteriOnay !== 'ONAYLADI' && (
                                        <button className="tkp-btn yesil" style={{ flex: 1, justifyContent: 'center', padding: '12px', fontSize: 15 }} disabled={isleniyor} onClick={() => islem('onayla')}>
                                            <i className="fas fa-check"></i>Randevuyu onaylıyorum
                                        </button>
                                    )}
                                    {veri.degistirilebilir && (
                                        <button className="tkp-btn" style={{ flex: 1, justifyContent: 'center', padding: '12px', fontSize: 15 }} onClick={() => { setDegistirAcik(true); setYeniGun(veri.ilkGun ?? ''); }}>
                                            <i className="fas fa-calendar-alt"></i>Saati değiştir
                                        </button>
                                    )}
                                    <button className="tkp-btn kirmizi" style={{ flex: 1, justifyContent: 'center', padding: '12px', fontSize: 15 }} onClick={() => setIptalAcik(true)}>
                                        <i className="fas fa-times"></i>İptal etmek istiyorum
                                    </button>
                                </div>
                            )}
                            {iptalAcik && (
                                <div style={{ background: '#fef2f2', borderRadius: 10, padding: 12 }}>
                                    <textarea className="tkp-girdi" rows={2} value={neden} onChange={e => setNeden(e.target.value)} placeholder="İptal nedeni (isteğe bağlı)" />
                                    <div style={{ display: 'flex', gap: 8, marginTop: 8, justifyContent: 'flex-end' }}>
                                        <button className="tkp-btn" onClick={() => setIptalAcik(false)}>Vazgeç</button>
                                        <button className="tkp-btn kirmizi" disabled={isleniyor} onClick={() => islem('iptal')}><i className="fas fa-times"></i>Randevuyu iptal et</button>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RandevuOnay;
